const state = {
    udyamList: undefined,
  };
export default state;
